import { EmitKeys } from '@/constants/global'
import { ActionType } from '@/typings/notification'

export const actionHandler: Record<ActionType, (bus: any, data?: any) => void> = {
  [ActionType.Subscribe]: async (bus) => {
    bus.emit(EmitKeys.SHOW_SUBSCRIBE)
  }
}
